// extracted by mini-css-extract-plugin
export default {"novoServico":"dashboardServico_novoServico__gF1gB","formSelectServico":"dashboardServico_formSelectServico__p3UvS","containerList":"dashboardServico_containerList__z096s"};